// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1zaxn","button":"_1FNOF"};